import styles from '/builds/servicebund/servicebund-websites/.build/releases/1/DistributionPackages/Servicebund.RodeoSteakDe/Resources/Private/Fusion/Presentation/Leaf/YouTubeVideo/YouTubeVideo.css';

export const prototypeName = 'Servicebund.RodeoSteakDe:Component.YouTubeVideo';
export {styles};